import styled, { css } from 'styled-components';
import Minus from '@widgets/shared/components/icons/Minus';
import Plus from '@widgets/shared/components/icons/Plus';
export const Label = styled.span `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;
const Icon = css `
  height: 1.4rem;
  width: 1.4rem;
  cursor: pointer;
  transition: fill 100ms linear;
`;
export const ButtonMinus = styled(Minus) `
  ${Icon}
`;
export const ButtonPlus = styled(Plus) `
  ${Icon}
`;
export const Element = styled.button `
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  touch-action: manipulation;
  border: none;
  padding: 0;
  line-height: 0;
  border: none;
  border-radius: 50%;
  width: 3.2rem;
  height: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 100ms linear;
  border-color: #e7e6eb;

  &:not(:disabled) {
    cursor: pointer;
    border: 0.1rem solid #e7e6eb;
    &:hover {
      border-color: #00aeef;
    }
  }

  &:disabled {
    svg {
      fill: #e7e6eb;
    }
  }

  ${({ theme: { attendeesButton } }) => attendeesButton}
`;
export default {
    Element,
    Label,
    Icon,
    Minus: ButtonMinus,
    Plus: ButtonPlus,
};
